/**
 * Config Module - Main Entry Point
 * Exports both constants and environment configuration
 *
 * Usage:
 * - Named imports (preferred): import { COMPANY_INFO, apiUrl } from 'config'
 * - Default import (legacy): import config from 'config'
 */

// Export all constants (non-environment dependent)
export {
  COMPANY_INFO,
  customerServicePhone,
  LegalOptInText,
  LegalOptInTextAdditional,
  IsSignatureAcceptedText
} from './constants';

// Export all environment configuration
export {
  apiUrl,
  tokenUrl,
  payixUrl,
  AuthorizationClientId,
  MobileViewBreakpoint,
  ApiRequestTimeoutMs,
  IsAllowGuarantorSignoff,
  AppTitle,
  defaultErrorMessage,
  defaultNetworkErrorMessage
} from './env';

// Default export for backward compatibility
// This maintains the same structure as before
import envConfig from './env';
import { COMPANY_INFO, customerServicePhone, LegalOptInText, LegalOptInTextAdditional, IsSignatureAcceptedText } from './constants';

export default {
  ...envConfig,
  COMPANY_INFO,
  customerServicePhone,
  LegalOptInText,
  LegalOptInTextAdditional,
  IsSignatureAcceptedText
};